import { useAemConfig } from '@as-react/common-components';
import { useSelector, useDispatch } from 'react-redux';
import { PDPVersion } from '@as-react/common-types';
import { ProductAddToBasketLocations } from '../enums/ActionEnums';
import { basketActions } from '../redux/basket/actions/BasketActions.creators';
import { makeGetBasketValidationState } from '../redux/basket/selectors/BasketSelector';
import { makeGetProductDefaults, makeGetProductFulfillment, makeGetSelectedColorId, makeGetSelectedSku, makeGetPriceInformation, makeGetProductFulfillmentBySize, makeGetSizeCombinationNotExist, } from '../redux/product/selectors/ProductSelector';
import { wishListActions } from '../redux/wishList/actions/WishListActions.creators';
import { makeGetProductColorIsInWishList } from '../redux/wishList/selectors/WishListSelectors';
import { analyticsActions } from '../redux/analytics/actions/AnalyticsActions.creators';
import { useProductDetailContext } from '../containers/product/ProductDetailV2Container';
export const useProductCTA = () => {
    const { isShopLanding, checkoutCc: clickAndCollectEnabled } = useAemConfig();
    const { selectedAdditionalProducts } = useProductDetailContext();
    const dispatch = useDispatch();
    const basketValidationState = useSelector(makeGetBasketValidationState());
    const productColorIsInWishList = useSelector(makeGetProductColorIsInWishList());
    const sizeCombinationNotExist = useSelector(makeGetSizeCombinationNotExist());
    const { productCode, productId, unavailableOnline } = useSelector(makeGetProductDefaults());
    const selectedColorId = useSelector(makeGetSelectedColorId());
    const selectedSku = useSelector(makeGetSelectedSku());
    const { hdExcluded, ccExcluded } = useSelector(makeGetProductFulfillment());
    const fulfillmentBySize = useSelector(makeGetProductFulfillmentBySize());
    const priceInformation = useSelector(makeGetPriceInformation());
    const dispatchAddToBasket = (quantity) => {
        dispatch(selectedAdditionalProducts.length > 0
            ? basketActions.createAddAdditionalProductsAction(selectedAdditionalProducts, quantity, ProductAddToBasketLocations.PDP)
            : basketActions.createAddAction(quantity, ProductAddToBasketLocations.PDP, PDPVersion.V2));
    };
    const toggleWishList = (wishListProduct) => {
        dispatch(wishListActions.toggleProduct(wishListProduct));
    };
    const dispatchOpenCC = () => {
        dispatch(basketActions.createCCPopupOpenAction());
        dispatch(analyticsActions.showStoreStock());
    };
    const dispatchSizeForgotten = () => dispatch(basketActions.createSizeForgottenShowAction());
    const wishListProduct = {
        colorId: selectedColorId,
        productCode: productCode,
        productId: parseInt(productId, 10),
        sku: selectedSku,
    };
    return {
        isShopLanding,
        clickAndCollectEnabled,
        dispatchAddToBasket,
        dispatchOpenCC,
        dispatchSizeForgotten,
        toggleWishList,
        productColorIsInWishList,
        wishListProduct,
        basketValidationState,
        sizeCombinationNotExist,
        unavailableOnline,
        selectedSku,
        hdExcluded,
        ccExcluded,
        fulfillmentBySize,
        priceInformation,
    };
};
